import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/B2BCLOUD-3327 Скрытие элементов интерфейса групповых политик */
export const PRAVDA_USER_POLICY_ENABLED = isFeature('pravda_user_policy');
